import { lazy, Suspense } from 'react';
import type { TiptapEditorProps } from './tiptap';
import { ReadinessGateHold } from 'Shared/react-mount-tracker';

const TiptapEditorComponent = lazy(() =>
   import('./tiptap').then(module => ({ default: module.TiptapEditor }))
);

export const TiptapEditor = (props: TiptapEditorProps) => (
   <Suspense
      fallback={
         <ReadinessGateHold>
            <div
               id={props.editorid}
               className="ProseMirror-menubar-wrapper min-h-[150px] rounded-md border border-gray-200 bg-gray-50"
            />
         </ReadinessGateHold>
      }
   >
      <TiptapEditorComponent {...props} />
   </Suspense>
);
